export default (messages = []) =>
  Array.isArray(messages) && messages.length > 0
    ? messages.map(({ text }) => text).join('\n')
    : 'Ocorreu um erro inesperado'

